import * as Sentry from '@sentry/vue';

export const initSentry = (app) => {
  if (import.meta.env.VITE_SENTRY_DISABLED) {
    return;
  }
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const tunnel = import.meta.env.VITE_SENTRY_TUNNEL;
  const api_url = import.meta.env.VITE_REST_URL;
  if (!dsn) {
    throw new Error('Missing VITE_SENTRY_DSN variable for initSentry');
  }

  Sentry.init({
    app,
    dsn,
    tunnel,
    environment: import.meta.env.MODE,
    integrations: [
      new Sentry.BrowserTracing({
        // tracePropagationTargets: ['localhost', api_url],
        routingInstrumentation: Sentry.vueRouterInstrumentation(app.router),
      }),
      new Sentry.Replay(),
    ],

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // bs errors
      'platform not available',
      'load cache timeout',
    ],
    beforeSend(event, hint) {
      if (hint?.originalException?.bam_error_type) {
        return null;
      }
      return event;
    },
  });
};

export const sendSentryMessage = (message, type) => Sentry.captureMessage(message, type);
